import { Box, Grid, Typography } from "@mui/material";
import { WindowSizeContext } from "../../../../common/context/WindowSizeContext";
import { useContext, useEffect } from "react";
import { useAvailableDateRange } from "../hooks";
import moment from "moment";
import InfoToolTip from "../Component/InfoToolTip";
import Item from "../../../../common/components/ItemCard";
import FreshHourlyTable from "./FreshHourlyTable";
import { useSelectorState, useSelectorValue } from "../../common/providers/selectorProvider";
import FilterTextDisplay from "../Filters/FilterTextDisplay";
import CompanySelector from "../Filters/Selectors/CompanySelector";
import RegionSelector from "../Filters/Selectors/RegionSelector";
import StoreSelector from "../Filters/Selectors/StoreSelector";
import CategorySelector from "../Filters/Selectors/CategorySelector";



export default function FreshHourlyOOSTableComponent({ tableName, filter, isOpen, setIsOpen }) {
    const { data: dateRangeData, isLoading: isDateRangeLoading } = useAvailableDateRange(tableName);
    const [startDate, setStartDate] = useSelectorState('start_date', null);
    const [endDate, setEndDate] = useSelectorState('end_date', null);
    const windowSize = useContext(WindowSizeContext)

    const selectedCompanyId = useSelectorValue('initial_company');
    const selectedRegion = useSelectorValue('initial_region');
    const selectedStores = useSelectorValue('initial_store');
    const selectedCategory = useSelectorValue('initial_category');




    const finalFilters = {
        days: filter?.days ?? '3',
        startDate: startDate ?? '',
        endDate: endDate ?? '',
        company_id: selectedCompanyId,
        region: selectedRegion,
        store: selectedStores,
        category: selectedCategory,
        // topSKU: filter?.topSKU ?? [...Array(20)].map((_, i) => `${i + 1}`)
    };

    let values;
    if (!filter || filter === undefined) {
        values = finalFilters;
    } else {
        values = filter;
    }

    useEffect(() => {
        if (dateRangeData?.max && values?.days) {

            if (values.days === 'ytd') {
                const newStart = moment(dateRangeData.max)
                    .startOf('year')
                    .format('YYYY-MM-DD');

                const newEnd = moment(dateRangeData.max).format('YYYY-MM-DD');

                setStartDate(newStart);
                setEndDate(newEnd);
                return;
            }

            const newStart = moment(dateRangeData.max)
                .subtract(values.days - 1, 'days')
                .format('YYYY-MM-DD');

            const newEnd = moment(dateRangeData.max).format('YYYY-MM-DD');

            setStartDate(newStart);
            setEndDate(newEnd);
        }
    }, [dateRangeData, values?.days, startDate, endDate]);



    const coverageStartDate = dateRangeData?.max
        ? values.days === 'ytd'
            ? moment(dateRangeData.max).startOf('year').format('MMMM DD, YYYY')
            : moment(dateRangeData.max).subtract(values.days - 1, 'days').format('MMMM DD, YYYY')
        : '---';

    const coverageEndDate = dateRangeData?.max
        ? moment(dateRangeData.max).format('MMMM DD, YYYY')
        : '---';

    return (
        <>
            <Box flexGrow={1} xs={12} sx={{ backgroundColor: '#f6f6f8', border: "1px solid #e0e0e0", borderRadius: ".5rem .5rem 0 0" }}>
                <Grid container xs={12} columnSpacing={windowSize.isOnMobile ? 0 : 1} rowSpacing={windowSize.isOnMobile ? 1.5 : .5} padding={1} >

                    <Grid item xs={12} md={4.5} sm={12} mx={1}>
                        <CompanySelector tableName={tableName} />
                    </Grid>
                    <Grid container xs={12} sm={12} md spacing={windowSize.isOnMobile ? 0 : 3} display="flex" alignItems="center" justifyContent="flex-end">
                        <Grid item xs={12} sm={12} md={4} mt={windowSize.isOnMobile ? 1 : 0}>
                            <CategorySelector tableName={tableName} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} mt={windowSize.isOnMobile ? 1 : 0}>
                            <StoreSelector tableName={tableName} />
                        </Grid>
                        <Grid item display="flex" alignItems="center" justifyContent="flex-end">
                            <InfoToolTip component={'table'} />
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            {/* <Grid item xs={12}>
                <FilterTextDisplay setIsOpen={setIsOpen} />
            </Grid> */}
            <Grid item xs={12} sx={{ boxShadow: "0px 0px 0px rgba(0, 0, 0, 0)" }} >
                <Item>
                    <FreshHourlyTable tableName={tableName} params={finalFilters} />
                </Item>
            </Grid >

        </>
    )
}